import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useSelector, useDispatch } from 'react-redux';

import { getCurrentSpinner } from 'src/store/spinner/selectors';
import { IFirstSpinner } from 'src/typings/spinner';
import { canShowPlacementInSpinner, showPlacementInSpinner } from 'src/store/spinner/show-placement';
import { usePolygonConfig } from 'src/components/ViewSpinner/components/RenderSvg/hooks';
import { useStyles } from './styles';
import { useStyles as useStylesIcon } from '../styles';
import { IEyeIcon } from './types';

export const EyeIcon: React.FC<IEyeIcon> = React.memo(({
  property,
}) => {
  const dispatch = useDispatch();
  const { globalPolygonConfig } = usePolygonConfig();
  const currentSpinner: IFirstSpinner | null = useSelector(getCurrentSpinner);
  const styles = useStyles(globalPolygonConfig);
  const stylesIcon = useStylesIcon();
  const handleHighlightEyeElement = () => {
    showPlacementInSpinner({ placement: property, currentSpinner, dispatch });
  };

  if (!canShowPlacementInSpinner(property, currentSpinner)) return null;

  return (
    <div className={`${stylesIcon.wrapperIcon} ${styles.wrapperEyeIcon}`}>
      <VisibilityIcon
        className={`${stylesIcon.imageIcon}`}
        onClick={handleHighlightEyeElement}
      />
    </div>
  );
});
